export const repetitionConstants = {
  GetPotentialRepeatedReOrgAppeals: {
    REQUEST: "GET_POTENITAL_REPEATED_RE_ORG_APPEALS_REQUEST",
    SUCCESS: "GET_POTENITAL_REPEATED_RE_ORG_APPEALS_SUCCESS",
    FAILURE: "GET_POTENITAL_REPEATED_RE_ORG_APPEALS_FAILURE",
  },

};
